import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Logout = () => {
  // We still import useAuth0 for consistency, but we won't use its logout function
  const { logout } = useAuth0();

  useEffect(() => {
    // Clear storage and cookies
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    document.cookie =
      "auth_token=; domain=.chefaicookware.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
    document.cookie =
      "auth_user=; domain=.chefaicookware.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;";

    // Determine environment from hostname
    const hostname = window.location.hostname;
    const isProduction = hostname.includes("chefaicookware.com");

    // CRITICAL: Explicitly select the proper client ID based on hostname
    // This bypasses any environment variable issues
    const clientId = isProduction
      ? "r5mqch0guM8PxxekbivXJ6H33UjG18u0" // Integration client ID
      : "xDPPZ49AW0tDk85kTF0PfuJj6tTHwSGy"; // Local client ID

    const redirectUrl = isProduction ? "https://chefaicookware.com" : "http://localhost:3000";
    const auth0Domain = "dev-axg87111x02bt0g3.us.auth0.com";

    // Construct Auth0 logout URL with the correct client ID
    const auth0LogoutUrl = `https://${auth0Domain}/v2/logout?client_id=${clientId}&returnTo=${encodeURIComponent(
      redirectUrl
    )}`;

    console.log("FINAL LOGOUT URL:", auth0LogoutUrl);

    // Redirect to Auth0 logout
    window.location.assign(auth0LogoutUrl);
  }, []);

  return null;
};

export default Logout;
